import layouts from '~/locales/languages/layouts/ru'

export default defineI18nLocale(() => {
  return {
    ...layouts,
  }
})
